import React from 'react'
import { useIntl } from 'react-intl'

import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  searchPhrase: string
  message: string
}

export default function NoResultsCopy({ searchPhrase, message }: Props) {
  const intl = useIntl()
  return (
    <div>
      <BodyText variant="medium" colour="neutral-two">
        {intl.formatMessage(
          {
            id: 'HTRSuhNwWjdKh2c7Vfqu',
            defaultMessage: 'Sorry, we couldn’t find results for <bold>\u2018{searchPhrase}’</bold>.',
            description: 'Message shown when no search results are found for the given search term',
          },
          {
            searchPhrase,
            bold: (chunks) => (
              <BodyText
                colour="neutral-one"
                as="span"
                variant="medium"
                weight="bold"
              >
                {chunks}
              </BodyText>
            ),
          },
        )}
      </BodyText>
      <BodyText variant="large" colour="neutral-two">
        {message}
      </BodyText>
    </div>
  )
}
